import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import IncidentsPage from './components/IncidentsPage';
import AgentsPage from './components/AgentsPage';
import UsersPage from './components/UsersPage';
import SettingsPage from './components/SettingsPage';
import InstallPage from './components/InstallPage';
import LogsPage from './components/LogsPage';
import ResetConfirm from './components/ResetConfirm';
import Pricing from './components/Pricing';
import SubscriptionPage from './components/SubscriptionPage';
import SuperAdminDashboard from './components/SuperAdminPage';

function App() {
  const [user, setUser] = useState(localStorage.getItem('user'));
  const [role, setRole] = useState(localStorage.getItem('role')); 

  const [email, setEmail] = useState(localStorage.getItem('user_email'));
  const [tenantId, setTenantId] = useState(localStorage.getItem('tenant_id'));

   const handleLogin = (username, userRole, userEmail, userTenantId) => {
    localStorage.setItem('user', username);
    localStorage.setItem('role', userRole);
    localStorage.setItem('user_email', userEmail);
    localStorage.setItem('tenant_id', String(userTenantId));
    
    setUser(username);
    setRole(userRole);
    setEmail(userEmail);
    setTenantId(String(userTenantId));
  };

  const handleLogout = () => {
    localStorage.clear(); 
    setUser(null);
    setRole(null);
    setEmail(null);
    setTenantId(null);
  };

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login onLogin={handleLogin} />} />
        <Route path="/reset-password/:token" element={<ResetConfirm />} />
        <Route path="/pricing" element={<Pricing onLogin={handleLogin} onLogout={handleLogout} />} />
        <Route path="/" element={
          !user ? <Navigate to="/login" /> : 
          (email === 'admin@skynix.co' && tenantId === '1') ? 
          <SuperAdminDashboard onLogout={handleLogout} /> : 
          <Dashboard onLogout={handleLogout} />
        } />

      <Route path="/incidents" element={user && email !== 'admin@skynix.co' ? <IncidentsPage onLogout={handleLogout} /> : <Navigate to="/" />} />
        <Route path="/infrastructure" element={user && email !== 'admin@skynix.co' ? <AgentsPage onLogout={handleLogout} /> : <Navigate to="/" />} />
        <Route path="/logs" element={user && email !== 'admin@skynix.co' ? <LogsPage onLogout={handleLogout} /> : <Navigate to="/" />} />
        <Route path="/subscription" element={user && email !== 'admin@skynix.co' ? <SubscriptionPage onLogout={handleLogout} /> : <Navigate to="/" />} />
        
        
        <Route path="/users" element={user ? <UsersPage onLogout={handleLogout} /> : <Navigate to="/" />} />
        <Route path="/settings" element={user ? <SettingsPage onLogout={handleLogout} /> : <Navigate to="/login" />} />
        <Route path="/install" element={user ? <InstallPage userRole={role} onLogout={handleLogout} /> : <Navigate to="/login" />} />
      </Routes>
    </Router>
  );
}

export default App;